/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Search_Sort_UpcomingInputs */

const id_search_sort_upcoming = /** @type {(inputs: Search_Sort_UpcomingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mendatang`)
};

const ms_search_sort_upcoming = /** @type {(inputs: Search_Sort_UpcomingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Akan datang`)
};

const da_search_sort_upcoming = /** @type {(inputs: Search_Sort_UpcomingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kommende`)
};

const de_search_sort_upcoming = /** @type {(inputs: Search_Sort_UpcomingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bevorstehend`)
};

const en_us2_search_sort_upcoming = /** @type {(inputs: Search_Sort_UpcomingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upcoming`)
};

const es_es2_search_sort_upcoming = /** @type {(inputs: Search_Sort_UpcomingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Próximos`)
};

const es_mx2_search_sort_upcoming = /** @type {(inputs: Search_Sort_UpcomingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Próximos`)
};

const fil_search_sort_upcoming = /** @type {(inputs: Search_Sort_UpcomingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paparating`)
};

const fr_search_sort_upcoming = /** @type {(inputs: Search_Sort_UpcomingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`À venir`)
};

const it_search_sort_upcoming = /** @type {(inputs: Search_Sort_UpcomingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prossimi`)
};

const hu_search_sort_upcoming = /** @type {(inputs: Search_Sort_UpcomingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Közelgő`)
};

const nl_search_sort_upcoming = /** @type {(inputs: Search_Sort_UpcomingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aankomend`)
};

const no_search_sort_upcoming = /** @type {(inputs: Search_Sort_UpcomingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kommende`)
};

const pl_search_sort_upcoming = /** @type {(inputs: Search_Sort_UpcomingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nadchodzące`)
};

const pt_br2_search_sort_upcoming = /** @type {(inputs: Search_Sort_UpcomingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por vir`)
};

const pt_search_sort_upcoming = /** @type {(inputs: Search_Sort_UpcomingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Próximos`)
};

const ro_search_sort_upcoming = /** @type {(inputs: Search_Sort_UpcomingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Viitoare`)
};

const fi_search_sort_upcoming = /** @type {(inputs: Search_Sort_UpcomingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tulevat`)
};

const sv_search_sort_upcoming = /** @type {(inputs: Search_Sort_UpcomingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kommande`)
};

const vi_search_sort_upcoming = /** @type {(inputs: Search_Sort_UpcomingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sắp tới`)
};

const tr_search_sort_upcoming = /** @type {(inputs: Search_Sort_UpcomingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yaklaşan`)
};

const cs_search_sort_upcoming = /** @type {(inputs: Search_Sort_UpcomingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nadcházející`)
};

const bg_search_sort_upcoming = /** @type {(inputs: Search_Sort_UpcomingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Предстоящи`)
};

const ru_search_sort_upcoming = /** @type {(inputs: Search_Sort_UpcomingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Предстоящие`)
};

const uk_search_sort_upcoming = /** @type {(inputs: Search_Sort_UpcomingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Майбутні`)
};

const ar_search_sort_upcoming = /** @type {(inputs: Search_Sort_UpcomingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`قادمة`)
};

const hi_search_sort_upcoming = /** @type {(inputs: Search_Sort_UpcomingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`आगामी`)
};

const th_search_sort_upcoming = /** @type {(inputs: Search_Sort_UpcomingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`กำลังจะมา`)
};

const ja_search_sort_upcoming = /** @type {(inputs: Search_Sort_UpcomingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`近日公開`)
};

const zh_cn2_search_sort_upcoming = /** @type {(inputs: Search_Sort_UpcomingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`即将发布`)
};

const zh_hant1_search_sort_upcoming = /** @type {(inputs: Search_Sort_UpcomingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`即將發布`)
};

const ko_search_sort_upcoming = /** @type {(inputs: Search_Sort_UpcomingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`출시 예정`)
};

/**
* | output |
* | --- |
* | "Upcoming" |
*
* @param {Search_Sort_UpcomingInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const search_sort_upcoming = /** @type {((inputs?: Search_Sort_UpcomingInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_Sort_UpcomingInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_search_sort_upcoming(inputs)
	if (locale === "ms") return ms_search_sort_upcoming(inputs)
	if (locale === "da") return da_search_sort_upcoming(inputs)
	if (locale === "de") return de_search_sort_upcoming(inputs)
	if (locale === "en-US") return en_us2_search_sort_upcoming(inputs)
	if (locale === "es-ES") return es_es2_search_sort_upcoming(inputs)
	if (locale === "es-MX") return es_mx2_search_sort_upcoming(inputs)
	if (locale === "fil") return fil_search_sort_upcoming(inputs)
	if (locale === "fr") return fr_search_sort_upcoming(inputs)
	if (locale === "it") return it_search_sort_upcoming(inputs)
	if (locale === "hu") return hu_search_sort_upcoming(inputs)
	if (locale === "nl") return nl_search_sort_upcoming(inputs)
	if (locale === "no") return no_search_sort_upcoming(inputs)
	if (locale === "pl") return pl_search_sort_upcoming(inputs)
	if (locale === "pt-BR") return pt_br2_search_sort_upcoming(inputs)
	if (locale === "pt") return pt_search_sort_upcoming(inputs)
	if (locale === "ro") return ro_search_sort_upcoming(inputs)
	if (locale === "fi") return fi_search_sort_upcoming(inputs)
	if (locale === "sv") return sv_search_sort_upcoming(inputs)
	if (locale === "vi") return vi_search_sort_upcoming(inputs)
	if (locale === "tr") return tr_search_sort_upcoming(inputs)
	if (locale === "cs") return cs_search_sort_upcoming(inputs)
	if (locale === "bg") return bg_search_sort_upcoming(inputs)
	if (locale === "ru") return ru_search_sort_upcoming(inputs)
	if (locale === "uk") return uk_search_sort_upcoming(inputs)
	if (locale === "ar") return ar_search_sort_upcoming(inputs)
	if (locale === "hi") return hi_search_sort_upcoming(inputs)
	if (locale === "th") return th_search_sort_upcoming(inputs)
	if (locale === "ja") return ja_search_sort_upcoming(inputs)
	if (locale === "zh-CN") return zh_cn2_search_sort_upcoming(inputs)
	if (locale === "zh-Hant") return zh_hant1_search_sort_upcoming(inputs)
	return ko_search_sort_upcoming(inputs)
});
export { search_sort_upcoming as "search.sort.upcoming" }